import appConfig from 'app-config';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

const isGpa = appConfig.portalCode === 'GPA';

export default {
    getPotentialExistingAccountsByHVQTransactionId(quoteID, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewaycompratorbridging'),
            'getPotentialExistingAccountsByHVQTransactionId',
            [quoteID],
            additionalHeaders);
    },

    createFromHVQTransactionIdOnExistingAccount(quoteID, accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewaycompratorbridging'),
            'createFromHVQTransactionIdOnExistingAccount',
            [quoteID, accountNumber],
            additionalHeaders);
    },

    createFromHVQTransactionIdOnNewAccount(hvqTransactionId, additionalHeaders = {}) {
        const proxiedUrl = isGpa ? 'gatewaycompratorbridging' : 'compratorbridging'
        return JsonRPCService.send(getProxiedServiceUrl(proxiedUrl),
            'createFromHVQTransactionIdOnNewAccount',
            [hvqTransactionId],
            additionalHeaders);
    },

    createFromHVQQuoteIdAndPostalCodeOnNewAccount(hvqQuoteId, zipCode, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('compratorbridging'),
            'createFromHVQQuoteIdAndPostalCodeOnNewAccount',
            [hvqQuoteId, zipCode],
            additionalHeaders);
    }
};
